// extracted by mini-css-extract-plugin
export default {"main":"maismenoslite_main__6IOBP","box":"maismenoslite_box__TziIy"};